/**
 * @license
 * Copyright 厦门乾元盛世科技有限公司 All Rights Reserved.
 *
 * Use of this source code is governed by an MIT-style license that can be
 * found in the LICENSE file.
 */



import { Component, Input, Output, EventEmitter, ElementRef, Renderer, ViewEncapsulation } from '@angular/core';
import { OnInit, HostListener, Inject, Optional, ContentChildren, QueryList, forwardRef } from '@angular/core';
import { NG_VALUE_ACCESSOR, COMPOSITION_BUFFER_MODE } from '@angular/forms';

import { FormControl } from '../input/form.control';
import { Checkbox } from './checkbox';
/**
 * @param {?} value
 * @return {?}
 */
function toArray(value) {
    let /** @type {?} */ ret = value;
    if (value === undefined) {
        ret = [];
    } else if (!Array.isArray(value)) {
        ret = [value];
    }
    return ret;
}

const /** @type {?} */ INPUT_CONTROL_VALUE_ACCESSOR: any = {
    provide: NG_VALUE_ACCESSOR,
    useExisting: forwardRef(() => CheckboxGroup),
    multi: true
};
export class CheckboxGroup extends FormControl implements OnInit {
/**
 * 样式前缀
 */
prefixCls = 'ant-checkbox-group';
/**
 * 用户CSS样式
 */
class: string;
/**
 * 值变更事件
 */
change = new EventEmitter<any>();
/**
 * 子列表
 */
children: QueryList<Checkbox>;
/**
 * @param {?} renderer
 * @param {?} elementRef
 * @param {?} compositionMode
 */
constructor(
private renderer: Renderer,
private elementRef: ElementRef,
private compositionMode: boolean) {

        super(renderer, elementRef, compositionMode);
        this.value = [];
    }
/**
 * @return {?}
 */
onClick(): void {
        this.onTouched(); // set your control to 'touched'
    }
/**
 * @return {?}
 */
ngOnInit(): void {
        this.value = toArray(this.value);
    }
/**
 * @param {?} value
 * @return {?}
 */
writeValue(value: any): void {
        if (value !== null) {
            this.value = toArray(value);
            // 更新子列表的checked状态
            this.toggleChildren();
        }
    }
/**
 * @param {?} value
 * @return {?}
 */
hasValue(value: any): boolean {
        return toArray(this.value).includes(value);
    }
/**
 * 当子选项发生变更时，也变更Group自身的值
 * @param {?} value
 * @param {?} checked
 * @return {?}
 */
toggle(value: any, checked: boolean): void {
        if (typeof value !== 'undefined') {
            const /** @type {?} */ array: any[] = this.value = toArray(this.value);
            const /** @type {?} */ contains = this.hasValue(value);
            if (checked && !contains) {
                array.push(value);
            }
            if (!checked && contains) {
                this.value = array.filter(v => v !== value);
            }
            this.onChange(this.value);
            this.change.emit(this.value);
        }
    }
/**
 * 更新子列表的checked状态
 * @return {?}
 */
toggleChildren(): void {
        this.children.forEach(checkbox => {
            checkbox.checked = this.hasValue(checkbox.value);
        });
    }
static decorators: DecoratorInvocation[] = [
{ type: Component, args: [{
    selector: 'ant-checkbox-group',
    template: `<ng-content></ng-content>`,
    encapsulation: ViewEncapsulation.None,
    providers: [INPUT_CONTROL_VALUE_ACCESSOR]
}, ] },
];
/**
 * @nocollapse
 */
static ctorParameters: () => ({type: any, decorators?: DecoratorInvocation[]}|null)[] = () => [
{type: Renderer, },
{type: ElementRef, },
{type: undefined, decorators: [{ type: Optional }, { type: Inject, args: [COMPOSITION_BUFFER_MODE, ] }, ]},
];
static propDecorators: {[key: string]: DecoratorInvocation[]} = {
'prefixCls': [{ type: Input },],
'class': [{ type: Input },],
'change': [{ type: Output },],
'children': [{ type: ContentChildren, args: [forwardRef(() => Checkbox), {descendants: true}, ] },],
'onClick': [{ type: HostListener, args: ['click', ['$event'], ] },],
};
}

function CheckboxGroup_tsickle_Closure_declarations() {
/** @type {?} */
CheckboxGroup.decorators;
/**
 * @nocollapse
 * @type {?}
 */
CheckboxGroup.ctorParameters;
/** @type {?} */
CheckboxGroup.propDecorators;
/**
 * 样式前缀
 * @type {?}
 */
CheckboxGroup.prototype.prefixCls;
/**
 * 用户CSS样式
 * @type {?}
 */
CheckboxGroup.prototype.class;
/**
 * 值变更事件
 * @type {?}
 */
CheckboxGroup.prototype.change;
/**
 * 子列表
 * @type {?}
 */
CheckboxGroup.prototype.children;
/** @type {?} */
CheckboxGroup.prototype.renderer;
/** @type {?} */
CheckboxGroup.prototype.elementRef;
/** @type {?} */
CheckboxGroup.prototype.compositionMode;
}


interface DecoratorInvocation {
  type: Function;
  args?: any[];
}
